import {
  defineComponent,
  ref,
  computed,
  watch,
  onMounted,
  onBeforeUnmount,
  nextTick,
  ComputedRef,
  PropType,
  Ref,
} from 'vue';
import Fraction from 'fraction.js';
import { Toast } from 'vant';
import { Native } from '@hb/mbridge';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import router from '@/router/index';
import { ModuleExposeOptions } from '~mall/common/directives/v-expose';

import {
  fetchCombiSellProduct,
  CombiProduct,
  requestSkuDetail,
} from '~mall/model/apis/ticketApis';
import {
  SkuDetailData,
} from '~mall/model/store/modules/ticket';
import {
  equityAdapter,
} from '~mall/model/utils';
import BottomConsentAgreement from '~mall/components/BottomConsentAgreement/index.vue';
import TicketEmpty from '~mall/components/TicketEmpty';
import { getStylesBinder } from '~mall/common/utils/styles';
// 20250627暂时关闭卡券商城首页 奖励金入口
// import SvipBar from './components/SvipBar';
// import SvipBarNew from './components/SvipBarNew';
import RewardCheckbox from '~mall/components/RewardCheckbox/index';
import { useRewardCheckbox } from '~mall/common/utils/useRewardCheckbox';

import { Package } from '~mall/constants/bike';
import { useBikePurchase } from '../bike/useBikePurchase';
import store from '~mall/model/store';
import { categoryMapArr, jumpToCategoryLink } from '~mall/common/utils/goMonthlyBike';
import { useActivityBuy } from '~mall/common/utils/useActivityBuy';
import openLowVersionModal from '~mall/components/LowVersionModal/index';
import {
  payWithSignNew,
  checkPayWithSignVersionCompatibility,
} from '~mall/model/apis/pay';
import NativeMgr from '~mall/common/native/native';
import { showThirdPage } from '~mall/common/utils/jumpUrl';
import {
  reqBuyGoods,
  BuyType,
} from '~mall/model/apis/order';
import { useCountDown } from '~mall/common/utils/useCountDown';
// import { appMgr } from '~mall/common/appMgr';
import { uiMgr } from '~mall/common/uiMgr';
import { secondToDate } from '~mall/common/utils/time';
import { appQueryConfig } from '~mall/common/utils/url';
import { isRentMini } from '~mall/common/utils/rentUtils';
import {
  isAliMP, isHelloFamilyApp, isEasyBikeApp, getAppEnv,
} from '~mall/common/env/env';
import styles from './index.module.less';
import CardDetail from './CardDetail/index';
import RentCouponCard from './RentCouponCard.vue';
import CombiSellBar from './CombiSellBar';
import UseNotice from './UseNotice';

const { handletwBikeBuy } = useBikePurchase();
const { handleActivityBuy: handleActivityBuyHook } = useActivityBuy();

const cx = getStylesBinder(styles);

  /** 限时购状态 */
  enum LimitStatus {
    /** 无限时抢购 */
    NO = -1,
    /** 已过期 */
    OUTDATED,
    /** 进行中 */
    ONGOING,
    /** 今天开始 */
    TODAY,
    /** 明天开始 */
    TOMORROW,
    /** 明天以后开始 */
    AFTER_TOMORROW,
  }

const TimerDescInit = { h: '00', m: '00', s: '00' };

export default defineComponent({
  name: 'TicketDetail',
  props: {
    query: {
      type: Object,
      default: () => ({}),
    },
    fullScreen: {
      type: Boolean,
      default: false,
    },
    getRef: {
      type: Function as PropType<(el: HTMLElement) => void>,
      default: () => {},
    },
  },
  setup: (props) => {
    const skuData = ref<SkuDetailData | null>(null);
    const timerDesc = ref(TimerDescInit);
    const limitStatus = ref<LimitStatus>(LimitStatus.NO);
    const limitEnd = ref(false);
    /** 是否选中并使用奖励金抵扣 */
    const svipChecked = ref(false);
    /** 奖励金是否展示中 */
    // const svipShowing = ref(false);

    /** 奖励金勾选逻辑 */
    const {
      rewardChecked,
      isRewardInPromo,
      isRewardOptional,
      showRewardCheckbox,
      rewardAmount,
      handleRewardChange,
      initRewardChecked,
      getMergedPromotionInfos,
    } = useRewardCheckbox(skuData);
    const combiProduct = ref<CombiProduct | null>(null);
    const combiProductLoaded = ref(false);
    /** 加价购商品是否选中 */
    const combiSellChecked = ref(false);
    const dataLoaded = ref(false);
    const dataFailLoaded = ref(false);
    const buying = ref(false);
    // const listProps = ref({ categoryId: '', categoryName: '' });
    // const guessRecmGood = ref({});
    // const spuIdTw = ref('');
    /** 是否替换全部tab下的两轮骑行卡 */
    // const replaceRideGoods = ref(false);

    /** 是否展示签协议信息 */
    const isShowBottomBuyTip = ref(true);
    /** 猜你喜欢的长度 */
    // const likeListLength = ref(0);
    /** 两轮骑行卡ab实验加载结果promise */
    // const _rideAbPromise: Promise<void> | null = null;

    // 活动倒计时相关
    const activityEndTime = ref<number>(0);

    // 使用倒计时 hook
    const {
      formatTimeText: formatActivityTimeText,
      isEnd: activityIsEnd,
      clear: clearActivityCountDown,
      start: startActivityCountDown,
    } = useCountDown({
      endTime: activityEndTime,
      autoStart: false,
      onEnd: () => {
        // 活动结束时的回调
      },
    });

    // 初始化活动倒计时
    const initActivityCountDown = (endTime: number) => {
      activityEndTime.value = endTime;
      startActivityCountDown();
    };

    // 是否展示加价购 默认展示
    const _enableCombiSell = ref(true);

    const bannerRef = ref<HTMLElement | null>(null);

    /** 是否全屏 */
    const isFullScreen = ref(props.fullScreen);
    watch(() => props.fullScreen, (val) => {
      isFullScreen.value = val;
    }, { immediate: true });

    /** 限时购计时器 */
    let _limitTimer: number | null = null;
    /** 是否展示加价购——限时购活动不展示 */
    const showCombiSell = computed(
      () => limitStatus.value === LimitStatus.NO,
    );

    const isTwBike = computed(() => {
      const { isTwBikeStr } = props.query;
      return !!isTwBikeStr;
    });
    const twBike: ComputedRef<Package> = computed(() => {
      const { twBikeStr = '{}' } = props.query;
      return JSON.parse(twBikeStr);
    });
    const cornerSign = computed(() => twBike.value?.marketingWords
        ?.filter(({ wordsType }) => wordsType === 1) || []);
    const categoryName = computed(() => props.query.categoryName);
    const categoryId = computed(() => props.query.categoryId);

    /** 限购是否有库存 */
    const hasLimitStock = computed(() => {
      if (skuData.value) {
        return (skuData.value.activityInfo?.saleStock || 0) > 0;
      }

      return false;
    });

    /** 非限购是否有库存 */
    const hasStock = computed(() => {
      if (skuData.value) {
        return skuData.value.saleNum > 0;
      }

      return false;
    });

    /** 是否有进行中的活动 */
    const hasOnGoingActivity = computed(
      () => limitStatus.value === LimitStatus.ONGOING && hasLimitStock.value,
    );

    /** 是否启用SVIP奖励金 */
    // const svipEnabled = computed(() => !hasOnGoingActivity.value);
    /** SVIP奖励金信息 */
    const svipData = computed(() => {
      const {
        isSuperUser = false,
        // superUserDiscountDTO: { amount } = { amount: 0 },
        promotionInfos = [],
      } = skuData.value || {};

      const amount = promotionInfos?.[0]?.worth || 0;
      return { isSuperUser, amount };
    });
      // const loadRideAb = async () => {
      //   if (!_rideAbPromise) {
      //     _rideAbPromise = (async () => {
      //       replaceRideGoods.value = await shouldReplaceRideGoods();
      //     })();
      //   }

    //   return _rideAbPromise;
    // };

    /** 是否展示租电动车组件 */
    const showRentCoupons = computed(
      () => isRentMini()
          && skuData.value?.extraInfo
          && String(skuData.value.extraInfo.businessId) === '99',
    );

    const countdownEnabled = computed(() => [LimitStatus.ONGOING, LimitStatus.TODAY]
      .includes(limitStatus.value));

    /** 是否能够购买 */
    const canBuy = computed(() => {
      if (!skuData.value) {
        return false;
      }

      const { canPurchase, saleNum } = skuData.value;
      return !!canPurchase && saleNum > 0;
    });
      /** 页面标题 */
    const pageTitle = computed(() => skuData.value?.categoryName || '商品详情');
    /** 获取实际售价：优先取服务端返回的优惠价 offerPrice，不存在时走原逻辑兜底 */
    const getRealSalePrice = (data: SkuDetailData) => {
      const {
        salePrice,
        offerPrice,
        // promotionInfos,
        // monthlyGoods,
        // monthlyContractChannel,
      } = data;

      /**
       * 连续包月
       * 历史逻辑售价：是用售价 - 优惠价
       * 20260416迭代优惠决策+奖励金抵现需求中，确定连续包月不在进行优惠决策，不会有优惠价
       * 所以去掉连续包月历史算价逻辑
       */
      // if (monthlyGoods) {
      //   const isAlipayChannel = monthlyContractChannel === 'alipay';
      //   const shouldCalculateMonthlyPrice = isAlipayChannel
      //     ? (isEasyBikeApp || isAliMP)
      //     : isEasyBikeApp;
      //   if (shouldCalculateMonthlyPrice) {
      //     const promoPrice = promotionInfos?.[0]?.worth || 0;
      //     return new Fraction(salePrice || 0).sub(promoPrice).valueOf();
      //   }
      // }

      // 服务端已计算好的优惠价格，优先使用
      if (offerPrice != null) {
        return offerPrice;
      }

      // 以下为 offerPrice 不存在时的兜底逻辑
      if (!hasOnGoingActivity.value) {
        return salePrice;
      }

      return data.activityInfo?.salePrice || salePrice;
    };
    const addPunctuationEnding = (str: string | undefined) => {
      if (!str) return str;
      if (!/[，,。]$/.test(str)) {
        return `${str}，`;
      }
      return str;
    };
    const skuDataAdapter = (_twBike: Package) => {
      const desc = _twBike.marketingWords?.map(({ wordsDescExt }) => addPunctuationEnding(wordsDescExt)).join('') || '';
      const finalDesc = (addPunctuationEnding(_twBike.commodityDesc) + desc).replace(/[，,。 ]$/, '。');

      return {
        categoryName: categoryName.value,
        categoryId: categoryId.value,
        ..._twBike,
        goodsName: _twBike.showName,
        salePrice: Number(_twBike.actualPrice.finalPrice),
        originalPrice: _twBike.originPrice,
        goodsEquitys: [{
          commodityDesc: _twBike.commodityDesc,
          effectDays: _twBike.cardBatchInfo.effectDay,
          virtualName: _twBike.showName,
        }],
        canPurchase: 1,
        saleNum: 1,
        useNotice: `<p>${finalDesc}</p>`,
        picUrl: categoryName.value === '单车' ? 'https://m.hellobike.com/resource/gallery/290/mEKGXEmP-B.png?x-oss-process=image/quality,q_80' : 'https://m.hellobike.com/resource/gallery/290/bdgBk4OhZq.png?x-oss-process=image/quality,q_80',
        skuId: _twBike.packageGuid,
      };
    };

    /** 获取价格信息 */
    const getPriceInfo = (
      data: SkuDetailData,
    ): {
      /** 总价 */
      totalPrice: number;
      /** 原总价 */
      totalOriginPrice: number;
      /** 总优惠金额 */
      totalPromoAmount: number;
      /** 实际售价——有限时购活动则展示活动售价 */
      realPrice: number;
      /** 详情浮层展示价格——与支付按钮一致但不含加价购 */
      displayPrice: number;
} => {
      const realSalePrice = new Fraction(getRealSalePrice(data)); // 获取实际售价
      let totalPrice = new Fraction(realSalePrice); // 总价
      let totalOriginPrice = new Fraction(data.originalPrice); // 原总价

      // 新奖励金价格处理
      if (isRewardInPromo.value && showRewardCheckbox.value) {
        // 奖励金在 promotionInfos 中：offerPrice 已包含奖励金抵扣
        // 用户取消勾选时，需要把奖励金金额加回去
        if (!rewardChecked.value) {
          totalPrice = totalPrice.add(rewardAmount.value);
        }
      } else if (isRewardOptional.value && showRewardCheckbox.value) {
        // 奖励金在 optionalPromotions 中：offerPrice 不含奖励金
        // 用户勾选时，需要减去奖励金金额（保底为 0，防止服务端数据异常导致负数价格）
        if (rewardChecked.value) {
          totalPrice = new Fraction(Math.max(totalPrice.sub(rewardAmount.value).valueOf(), 0));
        }
      }

      // 记录加价购前的价格，用于详情浮层展示（不含加价购，但包含奖励金等优惠）
      const displayPrice = new Fraction(totalPrice);

      if (combiSellChecked.value && combiProduct.value) {
        const { salePrice: combiSalePrice, originalPrice: combiOriginalPrice } = combiProduct.value;
        totalPrice = totalPrice.add(combiSalePrice);
        totalOriginPrice = totalOriginPrice.add(combiOriginalPrice);
      }

      // 将 Fraction 转换为 2 位小数
      const toFixedNumber = (fraction: Fraction, decimals = 2): number => {
        const num = fraction.valueOf();
        const p = Math.pow(10, decimals);
        return Math.round(num * p) / p;
      };

      return {
        realPrice: toFixedNumber(realSalePrice),
        displayPrice: toFixedNumber(displayPrice), // 不包含加价购的优惠价格
        totalPrice: toFixedNumber(totalPrice), // 包含加价购的优惠价格
        totalOriginPrice: toFixedNumber(totalOriginPrice),
        totalPromoAmount: Math.max(
          toFixedNumber(totalOriginPrice.sub(totalPrice)),
          0,
        ),
      };
    };

    /** 获取展示价格——优先秒杀价，否则取 displayPrice */
    const getDisplayPrice = (_priceInfo: ReturnType<typeof getPriceInfo>) => {
      if (skuData.value?.effectiveActivityInfo) {
        return skuData.value.effectiveActivityInfo.salePrice;
      }
      return _priceInfo.displayPrice;
    };

    const dataView = computed(() => {
      const { value } = skuData;

      if (!value) {
        return null;
      }
      const { goodsEquitys } = value;
      return {
        ...value,
        shortGoodsName: value.goodsName.length > 15 ? `${value.goodsName.slice(0, 15)}...` : value.goodsName,
        _benefits: (goodsEquitys || []).map((equity) => equityAdapter(equity)),
        _priceInfo: getPriceInfo(value),
      };
    });

    // 搭售商品埋点公共参数
    const getCombiUbtBusinessInfo = (combi: CombiProduct | null) => {
      if (!combi) {
        return null;
      }
      return {
        tyingGoodId: combi.spuId,
        tyingProductBusiness: combi.categoryId,
        tyingProductPrice: combi.salePrice,
        tyingProductName: combi.goodsName,
      };
    };

    const loadCombiProduct = async (data: SkuDetailData) => {
      combiSellChecked.value = false;
      combiProductLoaded.value = false;

      try {
        if (!showCombiSell.value) {
          return;
        }

        const res = await fetchCombiSellProduct({ spuId: data.spuId });
        combiProduct.value = res.data;

        if (combiProduct.value) {
          // 如果搭售是免费的，则自动选中
          // if (combiProduct.value.salePrice === 0) {
          //   combiSellChecked.value = true;
          // } else {
          //   combiSellChecked.value = false;
          // }

          // 搭售商品曝光埋点
          UBT.moduleExpose({
            pageId: 'platform_couponMerchantdetail',
            categoryId: 'platform',
            moduleId: 'platform_tyingProduct_expose',
            contentId: 'platform_tyingProduct_expose',
            exposureTimes: 1,
            businessInfo: getCombiUbtBusinessInfo(combiProduct.value) || {},
          });
        }
      } finally {
        combiProductLoaded.value = true;
      }
    };

    /** 清理限时购计时器 */
    const teardownLimitTimer = () => {
      if (_limitTimer) {
        window.clearInterval(_limitTimer);
        _limitTimer = null;
      }
    };

    /** 清理活动计时器 */
    const teardownActivityTimer = () => {
      clearActivityCountDown();
    };

    /** 设置活动计时器 */
    const setupActivityTimer = () => {
      if (!skuData.value?.effectiveActivityInfo) {
        return;
      }

      const { effectiveEndTime } = skuData.value.effectiveActivityInfo;
      initActivityCountDown(effectiveEndTime);
    };

    const setupLimitTimer = (useCurrTime: boolean) => {
      if (!skuData.value) {
        return;
      }

      teardownLimitTimer();
      let leftTime = 0;
      const { activityInfo } = skuData.value;

      if (countdownEnabled.value && activityInfo) {
        const now = Date.now();
        const initTime = (useCurrTime && activityInfo.currTime) || now;
        const targetTime = limitStatus.value === LimitStatus.ONGOING
          ? activityInfo.effectiveEndTime
          : activityInfo.effectiveStartTime;
        leftTime = Math.floor(((targetTime || now) - initTime) / 1000);
      }

      _limitTimer = window.setInterval(() => {
        if (leftTime <= 0) {
          teardownLimitTimer();

          if (limitStatus.value === LimitStatus.TODAY) {
            limitStatus.value = LimitStatus.ONGOING;
            setupLimitTimer(false);
          } else {
            limitEnd.value = true;
            limitStatus.value = LimitStatus.NO;
            timerDesc.value = TimerDescInit;
          }
        }
        timerDesc.value = secondToDate(leftTime);
        leftTime -= 1;
      }, 1000);
    };

    /** 初始化限时购 */
    const initLimit = (data: SkuDetailData) => {
      limitStatus.value = data.activityInfo?.timeLimitFlag || LimitStatus.NO;

      if (countdownEnabled.value) {
        setupLimitTimer(true);
      }
    };

    watch(
      () => skuData.value,
      (value) => {
        teardownLimitTimer();

        if (!value) {
          return;
        }

        initLimit(value);
        loadCombiProduct(value);
        // 启动活动计时器
        setupActivityTimer();

        // 初始化奖励金勾选默认状态
        initRewardChecked();
      },
    );

    watch(pageTitle, (value) => {
      if (!isHelloFamilyApp) {
        Native.setPageTitle({
          title: value,
        });
      }
    });

    const spuIdQuery = computed(() => {
      let { spuId = '' } = props.query;
      const questIndex = spuId.indexOf('?');

      if (questIndex !== -1) {
        spuId = spuId.slice(0, questIndex);
      }

      return spuId;
    });

    // 埋点字段：营销标签json字符串
    const marketingLabel = computed(() => skuData.value?.marketingTagName);
    // 埋点字段：highRecm
    const highRecm = computed(() => props.query?.highRecm || false);

    // 页面埋点公共参数
    const pageUbtBusinessInfo = computed(() => {
      const bizInfo = {
        marketingLabel: marketingLabel.value,
        isSupervalue: highRecm.value,
        adsource: appQueryConfig.adsource,
      };

      if (skuData.value) {
        const {
          skuId, spuId, salePrice, originalPrice, activityInfo, goodsName,
        } = skuData.value;
        return {
          ...bizInfo,
          skuId,
          spuId,
          // 划线价
          originalPrice: activityInfo?.salePrice ? salePrice : originalPrice,
          /** 券后价 */
          salePrice: activityInfo?.salePrice || salePrice,
          categoryid: categoryId.value,
          sku_name: goodsName,
        };
      }

      return bizInfo;
    });

    // 购买按钮曝光埋点配置
    const buyBtnExposeOptions = computed<ModuleExposeOptions>(() => ({
      exposeData: {
        pageId: 'platform_couponMerchantdetail',
        categoryId: 'platform',
        moduleId: 'platform_merchantdetail_buy',
        contentId: 'platform_merchantdetail_buy',
        exposureTimes: 1,
        businessInfo: {
          ...getCombiUbtBusinessInfo(combiProduct.value) || {},
          ...pageUbtBusinessInfo.value,
        },
      },
    }));

    const loadData = async () => {
      dataLoaded.value = false;
      dataFailLoaded.value = false;

      try {
        if (isTwBike.value) {
          // await getCityInfo();
          skuData.value = skuDataAdapter(twBike.value) as unknown as SkuDetailData;
          // loadData(props.noCard);
        } else { // 非二轮
          skuData.value = await requestSkuDetail({
            spuId: spuIdQuery.value,
            algorithmPriceFlag: props.query.algorithmPriceFlag
                || router.app.$route.query.algorithmPriceFlag,
          });
        }
        if (!skuData.value) {
          return;
        }

        // 页面进入埋点
        UBT.pageView({
          pageId: 'platform_couponMerchantdetail',
          categoryId: 'platform',
          businessInfo: pageUbtBusinessInfo.value,
        });
      } catch (e) {
        dataFailLoaded.value = true;
      } finally {
        dataLoaded.value = true;
      }
    };

    /** 设置事件监听 */
    const setupHandlers = () => {
      const handler = () => {
        if (document.visibilityState === 'visible') {
          if (!spuIdQuery.value) {
            return;
          }

          loadData();
        }
      };
      document.addEventListener('visibilitychange', handler);

      return () => {
        document.removeEventListener('visibilitychange', handler);
      };
    };
    const updateBottomBuyTip = (isGray: boolean) => {
      isShowBottomBuyTip.value = isGray;
    };
    let teardownHandlers: () => void;
    const init = async () => {
      teardownHandlers = setupHandlers();
      await loadData();
      nextTick(() => {
        if (bannerRef.value) {
          props.getRef(bannerRef.value);
        }
      });
    };

    // watch(
    //   () => props.query,
    //   (newQuery) => {
    //     console.log(22222,newQuery)
    //     // 更新 listProps
    //     const spuIdStr = newQuery.spuId;
    //     spuIdTw.value = spuIdStr;
    //     const listPropsValue = newQuery.listProps || "{}";
    //     // const guessRecm = newQuery.guessRecmGood || "{}";
    //     // listProps.value = JSON.parse(decodeURIComponent(listPropsValue));
    //     // guessRecmGood.value = JSON.parse(guessRecm);
    //     // 路径改变重新刷新页面
    //     init();
    //   },
    //   { immediate: true },
    // );

    onMounted(() => {
      init();
      store.commit('skuData/setSkuData', skuData.value);
    });

    // 监听刷新标记，下单后刷新详情数据
    watch(
      () => store.state.reward.detailRefreshFlag,
      () => {
        if (!isTwBike.value && spuIdQuery.value) {
          requestSkuDetail({
            spuId: spuIdQuery.value,
            algorithmPriceFlag: props.query.algorithmPriceFlag
              || router.app.$route.query.algorithmPriceFlag,
          }).then((res) => {
            if (res) {
              skuData.value = res;
            }
          }).catch(() => { /* 刷新失败不阻塞 */ });
        }
      },
    );

    onBeforeUnmount(() => {
      teardownLimitTimer();
      teardownActivityTimer();
      teardownHandlers();
      // 页面退出埋点
      UBT.pageViewOut({
        pageId: 'platform_couponMerchantdetail',
        categoryId: 'platform',
        businessInfo: pageUbtBusinessInfo.value,
      });
    });

    const displayOriginPriceTip = () => new Promise<void>((resolve) => {
      Toast('当前是非活动时段，下单前请注意购买金额');
      setTimeout(resolve, 1000);
    });

    const placeOrder = async (type: BuyType) => {
      if (!dataView.value) {
        return;
      }
      nextTick(() => {
        // UBT.clickButton({
        //   pageId: 'mkt_couponmall_itemdetail',
        //   buttonName: 'mkt_couponmall_itemdetail_buy',
        //   categoryId: 'market',
        //   businessInfo: ubtBizInfo,
        // });
      });
      const mergedPromotionInfos = getMergedPromotionInfos(dataView.value);

      await reqBuyGoods({
        skuData: { ...dataView.value, promotionInfos: mergedPromotionInfos },
        payAmount: dataView.value._priceInfo.totalPrice,
        buyType: type,
        svipAmount: svipChecked.value ? svipData.value.amount : undefined,
        combiProduct:
            (combiSellChecked.value && combiProduct.value) || undefined,
        highRecm: highRecm.value,
        isFromDetail: true,
      });
    };

    const payWithSignPreCheck = async () => {
      const { version } = await NativeMgr.getDeviceInfo();

      // 使用抽象的版本检查方法
      if (!checkPayWithSignVersionCompatibility(version) && isEasyBikeApp) {
        openLowVersionModal({
          confirm() {
            // UBT.clickButton({
            //   pageId: 'couponmall_list',
            //   buttonName: 'hellomall_appUpgrade',
            //   categoryId: 'hellomall',
            //   businessInfo: {
            //     spuIds: skuData.value?.spuId,
            //     adsource: appQueryConfig.adsource,
            //     marketingLabel: marketingLabel.value,
            //     version,
            //   },
            // });
          },
        });
        return;
      }
      if (!dataView.value) {
        return;
      }
      try {
        // 使用新的 payWithSignNew 方法，传入处理后的 promotionInfos
        const mergedPromotionInfos = getMergedPromotionInfos(dataView.value);
        await payWithSignNew({ ...dataView.value, promotionInfos: mergedPromotionInfos }, true);
      } catch (error) {
        // 支付签约失败
      }
    };

    const handleBuy = async () => {
      // 拼团商品
      if (skuData.value?.collageGoods === 1 && skuData.value?.collageLink) {
        showThirdPage(skuData.value?.collageLink);
        return;
      }
      // 连续包月
      if (skuData.value?.monthlyGoods) {
        // 支付宝渠道支持 App 和支付宝小程序，其他渠道只支持 App
        const isAlipayChannel = skuData.value?.monthlyContractChannel === 'alipay';
        const shouldPreCheck = isAlipayChannel
          ? (isEasyBikeApp || isAliMP)
          : isEasyBikeApp;
        if (shouldPreCheck) {
          payWithSignPreCheck();
          return;
        }
      }
      // 免密签约
      if (isEasyBikeApp && skuData.value?.passwordFreeGoods) {
        payWithSignPreCheck();
        return;
      }
      // app端跳转 (跳转到平台活动落地页中引导用于支付并签约+开通连续包月)， 小程序端正常购买下单
      if (isEasyBikeApp && skuData.value && categoryMapArr[getAppEnv() as 'fat' | 'uat' | 'pro']?.includes(skuData.value.categoryId)) {
        jumpToCategoryLink(getAppEnv() as 'fat' | 'uat' | 'pro', skuData.value.categoryId, skuData.value.spuId);
        return;
      }

      if (!dataView.value) {
        return;
      }

      if (buying.value) {
        return;
      }

      // 购买按钮点击埋点
      UBT.clickButton({
        pageId: 'platform_couponMerchantdetail',
        buttonName: 'platform_merchantdetail_buy',
        categoryId: 'platform',
        businessInfo: {
          ...getCombiUbtBusinessInfo(combiProduct.value) || {},
          ...pageUbtBusinessInfo.value,
        },
      });

      if (isTwBike.value) {
        handletwBikeBuy(buying, twBike, router, props.query.channelCodeStr, props.query.bizIdStr);
        return;
      }
      try {
        const buyType = hasOnGoingActivity.value
          ? BuyType.LIMIT
          : BuyType.NORMAL;

        if (buyType === BuyType.NORMAL && !canBuy.value) {
          return;
        }

        if (limitStatus.value > LimitStatus.ONGOING) {
          // 活动还没开始购买商品，给出提示
          await displayOriginPriceTip();
        }

        uiMgr.showLoading();
        await placeOrder(buyType);
      } finally {
        buying.value = false;
      }
    };
    function formatTimestamp(timestamp: number): string {
      const date = new Date(timestamp);
      const month = date.getMonth() + 1; // getMonth() 返回 0-11
      const day = date.getDate();
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${month}月${day}日 ${hours}:${minutes}`;
    }
    const limitBtnInfo = computed(() => {
      const { _priceInfo, activityInfo } = dataView.value!;
      const { effectiveStartTime, effectiveEndTime } = activityInfo!;
      const { totalPrice, totalPromoAmount } = _priceInfo;
      const { salePrice } = dataView.value!;

      const getMaxTimeUnit = (h: string, m: string, s: string) => {
        if (h !== '00') return `${parseInt(h, 10)}小时`;
        if (m !== '00') return `${parseInt(m, 10)}分钟`;
        if (m === '00' && m === '00' && s === '00') {
          return '';
        }
        return `${parseInt(s, 10)}秒`;
      };

      if (limitStatus.value !== LimitStatus.ONGOING) {
        return {
          tLBack: 'bg-coming-soon',
          bLWords: formatTimestamp(effectiveStartTime),
          tRWords: '活动未开始',
          bRWords: `${salePrice}元原价购买`,
        };
      }

      return limitEnd.value
        ? {
          tLBack: 'bg-ended',
          tRWords: '活动已售罄',
          bRWords: `${salePrice}元原价购买`,
          bLWords: formatTimestamp(effectiveEndTime),
        }
        : {
          tLBack: 'bg-ending-soon',
          tRWords: `${totalPrice}元抢购`,
          bRWords: `已优惠${totalPromoAmount}元`,
          bLWords: `距结束${getMaxTimeUnit(timerDesc.value.h, timerDesc.value.m, timerDesc.value.s)}`,
        };
    });

    /** 超级会员展示状态变化 */
    // const handleSvipShow = (val: boolean) => {
    //   svipShowing.value = val;

    //   if (val) {
    //     UBT.moduleExpose({
    //       pageId: 'couponmall_merchantdetail',
    //       categoryId: 'hellomall',
    //       moduleId: 'hellomall_rewards',
    //       contentId: 'hellomall_rewards',
    //       exposureTimes: 1,
    //       businessInfo: {
    //         adsource: appQueryConfig.adsource,
    //       },
    //     });
    //   }
    // };
    /** 超级会员奖励金抵扣状态变化 */
    // const handleSvipCheckedChange = (val: boolean) => {
    //   svipChecked.value = val;
    //   UBT.clickButton({
    //     pageId: 'couponmall_merchantdetail',
    //     buttonName: 'hellomall_rewards',
    //     categoryId: 'hellomall',
    //     businessInfo: {
    //       ischooserewards: val ? 1 : 2,
    //       skuId: skuData.value?.skuId,
    //       adsource: appQueryConfig.adsource,
    //     },
    //   });
    // };

    const isMallCard = computed(() => skuData.value?.goodsEquitys
        ?.some((item) => item.propertyType === 2));

    const footerRef = ref<HTMLElement | null>(null);
    const contentRef = ref<HTMLElement | null>(null);
    const barRef = ref<HTMLElement | null>(null);

    const handleActivityBuy = async () => {
    //   UBT.clickButton({
    //     pageId: 'couponmall_merchantdetail',
    //     buttonName: 'couponmall_merchantdetail_buy',
    //     categoryId: 'hellomall',
    //     businessInfo: {
    //       isflashsalegoods:
    //           props.query.newLimit === '1'
    //           || limitStatus.value === LimitStatus.ONGOING
    //             ? '是'
    //             : '否',
    //       isActivityGoods: dataView.value?.effectiveActivityInfo ? '1' : '0',
    //       ...sharedCombiUbtBizInfo.value,
    //       ...sharedUbtBizInfo.value,
    //       marketingLabel: marketingLabel.value,
    //     },
    //   });
      await handleActivityBuyHook(
        dataView.value,
          dataView.value?.categoryId || '',
      );
    };

    const renderPayBtn = () => {
      // 连续包月：支付宝渠道支持 App 和支付宝小程序，其他渠道只支持 App
      // 连续包月：20260416迭代优惠决策+奖励金抵现需求中确定该类型产品不支持优惠决策
      // 所以统一使用totalPrice对价格展示影响不大，同时又统一了价格计算逻辑
      if (skuData.value?.monthlyGoods) {
        const isAlipayChannel = skuData.value.monthlyContractChannel === 'alipay';
        const shouldRenderMonthlyBtn = isAlipayChannel
          ? (isEasyBikeApp || isAliMP)
          : isEasyBikeApp;

        if (shouldRenderMonthlyBtn) {
          const { salePrice, _priceInfo } = dataView.value || {};
          const monthlyContractChannel = skuData.value?.monthlyContractChannel;
          const channelText = monthlyContractChannel === 'alipay' ? `开通支付宝连续包月即享，次月起￥${salePrice}元/月续费` : `开通抖音连续包月即享，次月起￥${salePrice}元/月续费`;

          return (
                <div class={cx('buy-btn')} onClick={handleBuy}>
                  <div class={cx('buy-btn__text')}>
                    <div class={cx('btn__amount')}>
                      首月仅需￥{_priceInfo?.totalPrice} 元
                    </div>
                    <div class={cx('buy-btn__sub')}>
                      {channelText}
                    </div>
                  </div>
                </div>
          );
        }
      }
      // 免密支持优惠决策
      if (isEasyBikeApp && skuData.value?.passwordFreeGoods) {
        const { _priceInfo } = dataView.value || {};
        const passwordFreeContractChannel = skuData.value?.passwordFreeContractChannel;
        const channelText = passwordFreeContractChannel === 'alipay' ? '支付宝' : '抖音';
        return (
            <div class={cx('buy-btn')} onClick={handleBuy}>
              <div class={cx('buy-btn__text')}>
                <div class={cx('btn__amount')}>
                  补贴后仅需 {_priceInfo?.totalPrice} 元抢
                </div>
                <div class={cx('buy-btn__sub')}>
                  开通{channelText}免密支付既享
                </div>
              </div>
            </div>
        );
      }

      // 秒杀不支持优惠决策
      if (skuData.value?.effectiveActivityInfo) {
        const { salePrice } = skuData.value?.effectiveActivityInfo || {};
        const getActivityTimeText = () => {
          if (activityIsEnd.value) {
            return '活动已结束';
          }
          return `${formatActivityTimeText()}后结束`;
        };

        return (
            <div class={cx('buy-activity-btn')} onClick={handleActivityBuy}>
              <div class={cx('buy-activity-info')}>
                <span class={cx('buy-activity-info-title')}>
                  <img src="https://m.hellobike.com/resource/gallery/99/jmE_5r8ih9.png?x-oss-process=image/quality,q_80" />
                </span>
                <span class={cx('buy-activity-info-time')}>
                  {getActivityTimeText()}
                </span>
              </div>
              <div class={cx('buy-btn__right')}>
                <span class={cx('buy-btn__right_amount')}>
                  {salePrice}
                </span>
                <span>元抢购</span>
              </div>
            </div>
        );
      }

      const { totalPrice, totalPromoAmount } = dataView.value?._priceInfo || {};
      const hasLimit = limitStatus.value !== LimitStatus.NO;

      const {
        btnType,
        btnText,
        showAmount,
      } = (() => {
        if (limitStatus.value === LimitStatus.ONGOING) {
          if (hasLimitStock.value) {
            return {
              btnType: 'limit-now-one',
              btnText: '抢购',
              showAmount: true,
            };
          }
          if (!hasStock.value) {
            return {
              btnType: 'limit-no',
              btnText: '已抢完',
              showAmount: false,
            };
          }
        }
        const useOriginPrice = limitStatus.value >= LimitStatus.ONGOING;
        return {
          btnType: '',
          btnText: (() => {
            if (useOriginPrice) {
              return '原价购买';
            }
            if (canBuy.value) {
              return '抢购';
            }
            return dataView?.value?.canPurchase
              ? '卖光了'
              : '商品已下架';
          })(),
          showAmount: !useOriginPrice && canBuy.value,
        };
      })();
      return (
            <div>
              {hasLimit ? (
                <div class={cx('buy-btn-limit')} onClick={handleBuy}>
                  <div class={cx('grid-item', 'left', 'left-top', limitBtnInfo.value.tLBack)}></div>
                  <div class={cx('grid-item', 'right', 'right-top')}>{limitBtnInfo.value.tRWords}</div>
                  <div class={cx('grid-item', 'left', 'left-bottom')}>{limitBtnInfo.value.bLWords}</div>
                  <div class={cx('grid-item', 'right', 'right-bottom')}>{limitBtnInfo.value.bRWords}</div>
                </div>
              ) : (
                <div
                  class={cx('buy-btn', {
                    'buy-btn_disabled': !canBuy.value,
                    [`buy-btn_${btnType}`]: !!btnType,
                  })}
                  onClick={handleBuy}
                >
                  {isShowBottomBuyTip.value && isTwBike.value ? (
                    <div>
                      <span class={cx('buy-btn__access')}>同意并支付</span>
                      <span class={cx('buy-btn__amount')}>{totalPrice}</span>
                      <span>元</span>
                      {showAmount && !!totalPromoAmount && (
                        <div class={cx('buy-btn__sub')}>
                          已优惠 {totalPromoAmount}元
                        </div>
                      )}
                    </div>
                  ) : (
                    <div>
                      {showAmount && [
                        <span class={cx('buy-btn__amount')}>{totalPrice}</span>,
                        <span>元</span>,
                      ]}
                      <span>{btnText}</span>
                      {showAmount && !!totalPromoAmount && (
                        <div class={cx('buy-btn__sub')}>
                          已优惠 {totalPromoAmount}元
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
              {isShowBottomBuyTip.value && (isTwBike.value || isMallCard.value)
              && <BottomConsentAgreement
                show={isShowBottomBuyTip.value}
                handleUpdateBottomTip={updateBottomBuyTip}
                categoryName={categoryName.value}
                textColorStyle={'color: #040000;'}
              />
                }
            </div>
      );
    };

    return () => {
      const hasLimit = limitStatus.value !== LimitStatus.NO;
      const computedHeight = () => {
        if (barRef.value?.combiContentRef?.clientHeight) {
          return `${Number(contentRef.value?.clientHeight) - Number(barRef.value?.combiContentRef?.clientHeight) - Number(footerRef.value?.clientHeight)}px`;
        }
        return `${Number(contentRef.value?.clientHeight) - Number(footerRef.value?.clientHeight) - 12}px`;
      };
      return (
          <div class={cx({ ticket_limit: !hasLimit })}>
            {(() => {
              if (!dataLoaded.value) {
                return null;
              }
              if (dataFailLoaded.value) {
                return (
                  <TicketEmpty
                    imgAttrs={{
                      src: 'https://m.hellobike.com/resource/helloyun/18121/s7R3W_icon_yichang@2x.png',
                      width: '2.7rem',
                      height: '1.6rem',
                    }}
                    desc="网络不太顺畅哦，请点击重试"
                    btnText="重新加载"
                    btnHandler={loadData}
                  />
                );
              }
              if (!dataView.value) {
                return <TicketEmpty />;
              }
              const {
                shortGoodsName,
                originalPrice,
                // salePrice,
                useNotice,
                marketingWords,
                _benefits,
                _priceInfo,
                listPicUrl,
                picUrl,
                goodsTags,
                canAutoRefund,
              } = dataView.value;
              return (
                <div>
                  <div
                    class={cx('main')}
                  >
                    <div class={cx('prod__img-wrap')}>
                      <van-image
                        lazy-load
                        class={cx('prod__img')}
                        src={listPicUrl || picUrl}
                      />
                    </div>
                    <div class={cx('banner-wrap')} ref={bannerRef}>
                      <div class={cx('banner-wrap-content')}>
                        <div class={cx('title')}>{shortGoodsName}</div>
                        <div class={cx('price-wrap')}>
                          <span class={cx('true-price')}>{getDisplayPrice(_priceInfo)}</span>
                          <span class={cx('original-price')}>
                            ¥{originalPrice}
                          </span>
                        </div>
                        {(cornerSign.value.length > 0
                          || goodsTags?.length > 0
                          || canAutoRefund
                        ) ? (<div class={cx('sub-info')}>
                        {cornerSign.value.length > 0 ? cornerSign.value.map((item) => <span class={cx('goods-tag')}>{item.wordsValue || ''}</span>) : ''}
                        {canAutoRefund ? <span class={cx('goods-tag', 'auto-refund')}>过期自动退</span> : ''}
                        {goodsTags?.map((item) => <span class={cx('goods-tag')}>{item}</span>)}
                      </div>) : null}
                      </div>
                    </div>
                    <div class={cx('content-wrap')}>
                      <div class={cx('content')} ref={contentRef}>
                        <div class={cx('temp')}
                          style={{ height: computedHeight() }}>
                          <div class={cx('info-wrap')}>
                            <div class={cx('package-info')}>
                              <div class={cx('package-title')}>套餐详情</div>
                              <CardDetail
                                cardList={_benefits}
                              />
                            </div>
                            {showRentCoupons.value && <RentCouponCard />}
                            <div class={cx('use-notice')}>
                              <UseNotice
                                title="使用须知"
                                desc={useNotice || ''}
                                isFullScreen={isFullScreen.value}
                                twoWheelCardDescList={marketingWords}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {(() => (
                      <div
                        class={cx(
                          'footer',
                          (showCombiSell.value && combiProduct.value) && ['footer_combi'],
                        )}
                        ref={footerRef as Ref<HTMLElement>}
                        v-node-expose={buyBtnExposeOptions.value}
                      >
                        {/* 搭售栏：放在 footer 内部顶部，通过负 margin 探出 footer */}
                        {(() => {
                          if (!showCombiSell.value || !combiProduct.value) {
                            return null;
                          }
                          return (
                            <div class={cx('bar-inner', { 'bar-inner-unfree': !!combiProduct.value?.salePrice })}>
                              <CombiSellBar
                                data={combiProduct.value}
                                value={combiSellChecked.value}
                                ref={barRef}
                                {...{
                                  on: {
                                    input: (value: boolean) => {
                                      combiSellChecked.value = value;
                                    },
                                  },
                                }}
                              />
                            </div>
                          );
                        })()}
                        {/* 奖励金+按钮容器：带圆角白色背景，压在搭售栏上面 */}
                        <div class={cx('footer-content-wrap')}>
                          {/* 奖励金勾选项：位于购买按钮上方 */}
                          {showRewardCheckbox.value && (
                            <RewardCheckbox
                              checked={rewardChecked.value}
                              amount={rewardAmount.value}
                              {...{
                                on: {
                                  change: handleRewardChange,
                                },
                              }}
                            />
                          )}
                          {
                            renderPayBtn()
                          }
                        </div>
                      </div>
                  ))()}
                </div>
              );
            })()}
          </div>
      );
    };
  },
});
